module.exports = __webpack_public_path__ + "img/keen-slider-loader.7d7e0ae.svg";